import React, { Component } from 'react';
import classNames from 'classnames';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { DatePicker } from '../Common/datePicker';
import { DisabledInputField } from '../Common/inputField';
import PriceFormatter from '../Common/priceFormatter';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';
import { Selection } from '../Common/selection';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isRivera } from '../../actions/root_url';

const isEcity = ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/"|| ROOT_API_URL === 'https://ct-scm.truckxi.com/api/';

momentLocalizer(moment);

const getBsStyle = (input, value) => {
  return input === value ? 'success':'primary'
};

class RowRenderer extends Component {
  render() {
    //here we are just changing the style
    //but we could replace this with anything we liked, cards, images, etc
    //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }} ><ReactDataGrid.Row ref='row' {...this.props} /></div>);
  }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func
};

const renderCustomerTypeRadios = props => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.error }, 'col-xs-4');
  return (
    <ButtonToolbar className='long-radio-filter-buttons'>
      <Button bsStyle={getBsStyle(props.input.value, 'all')}>
        <div className='radio'>
          <label for='all-radio-filter'>
            <input {...props.input} id='all-radio-filter' type='radio' name='statusFilterRadios' value='all' checked={props.input.value === 'all'}/>
            <Translate value="all" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Active')}>
        <div className='radio'>
          <label for='active-radio-filter'>
            <input {...props.input} id='active-radio-filter' type='radio' name='statusFilterRadios' value='Active' checked={props.input.value === 'Active'}/>
            <Translate value="active" />
          </label>
        </div>
      </Button>
      <Button bsStyle={getBsStyle(props.input.value, 'Inactive')}>
        <div className='radio'>
          <label for='inactive-radio-filter'>
            <input {...props.input} id='inactive-radio-filter' type='radio' name='statusFilterRadios' value='Inactive' checked={props.input.value === 'Inactive'}/>
            <Translate value="inactive" />
          </label>
        </div>
      </Button>
    </ButtonToolbar>
  )
}


class CustomerStatementMain extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,
      rows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,

      amount00_07: 0,
      amount08_30: 0,
      amount00_30: 0,
      amount31_60: 0,
      amount61_90: 0,
      amount_91: 0,
      current: 0,
      grand_amount: 0,
      Days: '',
      PaymentTerm: '',
    };
    this.handleResize = this.handleResize.bind(this);
    this.fetchCustomerStatementList = this.fetchCustomerStatementList.bind(this);
    this.statementDetail = this.statementDetail.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultOfForm('typeRadios', 'Active', 'customerStatementMain');
    this.props.setDefaultOfForm('Days', new Date(), 'customerStatementMain');
    this.props.setDefaultOfForm('PaymentTerm', '', 'customerStatementMain');
    this.props.fetchCustomerStatementList('Active', moment().format('YYYY-MM-DD'));
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchPaymentTerms();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.typeRadios) {
      this.props.setDefaultOfForm('typeRadios', 'Active', 'customerStatementMain');
    }
    if (!nextProps.Days) {
      this.props.setDefaultOfForm('Days', new Date(), 'customerStatementMain');
    }
    if (!nextProps.PaymentTerm) {
      this.props.setDefaultOfForm('PaymentTerm', '', 'customerStatementMain');
    }
    if (nextProps.customerStatementList && nextProps.customerStatementList !== this.props.customerStatementList) {
      const {
        statement_lines,
        amount00_07,
        amount08_30,
        amount00_30,
        amount31_60,
        amount61_90,
        amount_91,
        current,
        grand_amount,
      } = nextProps.customerStatementList;

      this.setState({
        rows: statement_lines,
        amount00_07: parseFloat(amount00_07).toFixed(2) || 0,
        amount08_30: parseFloat(amount08_30).toFixed(2) || 0,
        amount00_30: parseFloat(amount00_30).toFixed(2) || 0,
        amount31_60: parseFloat(amount31_60).toFixed(2) || 0,
        amount61_90: parseFloat(amount61_90).toFixed(2) || 0,
        amount_91: parseFloat(amount_91).toFixed(2) || 0,
        current: parseFloat(current).toFixed(2) || 0,
        grand_amount: parseFloat(grand_amount).toFixed(2) || 0,
      });
    }

    if (nextProps.typeRadios && nextProps.typeRadios !== this.props.typeRadios) {
      if (this.props.Days){
        let days = moment(this.props.Days).format('YYYY-MM-DD');
        this.props.fetchCustomerStatementList(nextProps.typeRadios, days, this.state.PaymentTerm );
      }
    }
    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      const { Days } = nextProps;
      this.setState({ Days }, this.fetchCustomerStatementList);
    }
    if (nextProps.PaymentTerm && nextProps.PaymentTerm !== this.props.PaymentTerm) {
      const { PaymentTerm } = nextProps;
      this.setState({ PaymentTerm }, this.fetchCustomerStatementList);
    }
    if (this.props.PaymentTerm && nextProps.PaymentTerm == null) {
      this.setState({ PaymentTerm: '' }, this.fetchCustomerStatementList);
    }
  }

  handleResize(e) {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.customersPage });
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';
    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  statementDetail() {
    const currentCustomer = arguments[0];
    this.props.resetCurrentCustomer();
    this.props.selectCustomer(currentCustomer);
    this.context.router.push('/customerStatement');

  }
  // this.context.router.push('/products/'+currentInventory.Product_id);

  fetchCustomerStatementList() {
    if (this.state.Days){
      let days = moment(this.state.Days).format('YYYY-MM-DD');
      this.props.fetchCustomerStatementList(this.props.typeRadios, days, this.state.PaymentTerm);
    }
  }
  
  getPaymentTerms() {
    const PaymentTerms = [];
    this.props.paymentTerms.map((payment) => {
      PaymentTerms.push({ value: payment.id, label: payment.name });
    });
    return PaymentTerms;
  }
  
  renderPaymentTerms() {
    if (this.props.isLoading) return <Spinner />; // If is loading, show a spinner.
    const PaymentTerms = this.getPaymentTerms();
    return (
      <div style={{ width: "130px" }}>
        <Field name="PaymentTerm" component={Selection} options={PaymentTerms} />
      </div>
    );
  }

  renderTable() {
    if (this.props.customerStatementListIsLoading && !this.props.customerStatementListError) {
      return (
        <div id="spinner">
          <Spinner/>
        </div>
      );
    } else if (this.props.customerStatementListError) {
      return (
        <div className="alert alert-danger">
          <Translate value="something_unexpected_happened" />
        </div>
      );
    } else {
        // Parameters of the react-data-grid
        let tableHeight = (window.innerHeight < 930) ? 510 : 510;

        const getRows = () => {
          return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
          return getRows().length;
        }

        const rowGetter = rowIdx => {
          var rows = getRows();
          return rows[rowIdx];
        }

        // Handle the sortable function
        const handleGridSort = (sortColumn, sortDirection) => {
          this.setState(prevState => ({
            ...prevState,
            sortColumn,
            sortDirection,
          }));
        }

        const handleFilterChange = filter => {
          let newFilters = Object.assign({}, this.state.filters);
          if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
          } else {
            delete newFilters[filter.column.key];
          }
          this.setState({ filters: newFilters });
        }

        //Custom Formatter component
        const DateFormatter = React.createClass({
          render() {
            if (this.props.value) {
              let dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              let date = new Date(this.props.value)
              let index = dateMap.indexOf(date.toString().slice(4,3));
              let localDate = index + date.toString().slice(8, 6);
              return <span>{date.toString().slice(4, 15)}</span>;;
            }
            else return <span className='label label-danger'>-</span>;
          }
        });

        // Column difinition
        const columns = [
          {
            key: 'CustomerNum',
            name: <Translate value="customer_num" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 120,
          },
          {
            key: 'Name',
            name: <Translate value="customer_name" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 200,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
          },
          /* { // Commented 11/17/17 branch: feature/ARAP
              key: 'current',
              name: <Translate value="current" />,
              resizable: true,
              sortable: true,
              width: 80,
              formatter: PriceFormatter,
          }, */
          {
            key: 'PaymentTerm_Name',
            name: <Translate value="payment_term" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
          },
          {
            key: 'amount00_30',
            name: <Translate value="00_dashsign_30_days" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 80,
            formatter: CashFormatter,
          },
          {
            key: 'amount31_60',
            name: <Translate value="31_dashsign_60_days" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 80,
            formatter: CashFormatter,
          },
          {
            key: 'amount61_90',
            name: <Translate value="61_dashsign_90_days" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 80,
            formatter: CashFormatter,
          },
          {
            key: 'amount_91',
            name: <Translate value="91_plussign_days" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 80,
            formatter: CashFormatter,
          },
          {
            key: 'total_amount',
            name: <Translate value="total_amount" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
            formatter: CashFormatter,
          },
          {
            key: 'Sales_User_Name',
            name: <Translate value="sales" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 100,
          },
        ]

        if (isEcity) {
          const indexEstDelivery = _.findIndex(columns, { key: 'amount00_30' });
          const estColum1 = {
            key: 'amount00_07',
            name: <Translate value="00_dashsign_07_days" />,
            resizable: true,
            sortable: true,
            width: 80,
            formatter: CashFormatter,
          };
          const estColum2 = {
            key: 'amount08_30',
            name: <Translate value="08_dashsign_30_days" />,
            resizable: true,
            sortable: true,
            width: 80,
            formatter: CashFormatter,
          };
          columns.splice(indexEstDelivery, 1, estColum1);
          columns.splice(indexEstDelivery+1, 0, estColum2);
        }

        //React Table Purchase Order Full Table
        return (
          <Row>
            <Col sm={ 12 }>
              <div className='react-table-ar-ap-customer-list-statement' id="CustomerStatementMain-dataGrid1">
                <ReactDataGrid
                  rowRenderer={<RowRenderer onDoubleClick={this.statementDetail} />}
                  rowKey='Deliver_Customer_id'
                  enableCellSelect={true}
                  onGridSort={handleGridSort}
                  columns={columns}
                  rowHeight={25}
                  headerRowHeight={45}
                  rowGetter={rowGetter}
                  rowsCount={getSize() }
                  minHeight={tableHeight}
                  // toolbar={<Toolbar enableFilter />}
                  // onAddFilter={handleFilterChange}
                />
              </div>
            </Col>
          </Row>
        )
    }
  }

  renderSimplifiedExportButton() {
    const { typeRadios } = this.props;
    let { Days: date } = this.props;
    date = moment(date).endOf('day').toISOString();
    date = `PostingDate=${date}`;
    const token = localStorage.getItem('token');
    const url = `${ROOT_URL}v1/ar/statement/excel/${typeRadios || 'Active'}/?${date}&Bearer=${token}`;
    return (
      <Button
        bsStyle='success'
        type='button'
        href={url}
      >
        <em className='fa fa-download' />
        <Translate value="simplified_excel" />
      </Button>
    );
  }

  renderDetailedExportButton() {
    const { typeRadios } = this.props;
    let { Days: date } = this.props;
    date = moment(date).endOf('day').toISOString();
    date = `PostingDate=${date}`;
    const token = localStorage.getItem('token');
    const exportUrl = `${ROOT_URL}v1/ar/report/aged/${typeRadios || 'Active'}/excel/?${date}&Bearer=${token}`;
    return (
      <Button
        bsStyle='success'
        className='pull-right'
        href={exportUrl}
      >
        <em className='fa fa-download' />
        <Translate value="detailed_excel" />
      </Button>
    );
  }

  render() {
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active='true'>
            <Translate value="ar_aged_report" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar>
          {/*
            <Button bsStyle='primary' href={print_url} >
              <em className='fa fa-print' /><Translate value="print" />
              </Button>
          */}
          { this.renderSimplifiedExportButton() }
          { this.renderDetailedExportButton() }
        </ButtonToolbar>
        <Grid id='customer-statement'>
          {/* <h1><Translate value="ar_aged_report" /></h1> */}
          {/* Date Range Pickers */}
          <Col xs={ 12 }>
            <Panel id='date-range-picker' className='form-horizontal'>
              <Row>
                <Col xs={ 2 }>
                  <h3 className="text-right text-nowrap"><Translate value="statement_date" /><span classNames="colon">:</span></h3>
                </Col>
                <Col xs={ 10 }>
                  <div id="statusFilterRadios">
                    <ButtonToolbar className='radio-filter-buttons'>
                      <Button bsStyle='primary'>
                        <Field name='Days' placeholder={'Date'} component={DatePicker} />
                      </Button>
                      {/* <Button
                        bsStyle='primary'
                        className='search-btn'
                        type='submit'
                        onClick={() => { this.fetchCustomerStatementList(); }}
                      >
                        <em className='fa fa-search' />
                      </Button> */}
                    </ButtonToolbar>
                  </div>
                </Col>
                <Col xs={ 2 }>
                  <h3 className="text-right text-nowrap"><Translate value="customer_status" /><span classNames="colon">:</span></h3>
                </Col>
                <Col xs={ 10 }>
                  <div id="statusFilterRadios">
                    <Field name='typeRadios' component={renderCustomerTypeRadios} />
                  </div>
                </Col>
              </Row>
            </Panel>
            <Row>
              <Col xs={ 12 }>
                <Panel className="position-relative mb0" id="table-height-fix">
                {
                  isRivera &&
                  <div style={{ display: "flex" }}>
                    <label
                      style={{ marginRight: "10px", marginBottom: "10px" }}
                      className="control-label"
                    >
                      <Translate value="payment_term_short" />
                    </label>
                    {this.renderPaymentTerms()}
                  </div>
                }
                  {/* Render Inventory Table  */}
                  {this.renderTable() }
                </Panel>
              </Col>
              <Col xs={ 12 }>
                <Panel className="position-relative mb0">
                  {/* <Col xs={ 2 }> Commented 11/17/17 branch: feature/ARAP
                    <label className='col-xs-6'><Translate value="current" /></label>
                    <Col xs={ 5 }>
                      <Field name='current' component={DisabledInputField} placeholder={this.state.current}/>
                    </Col>
                  </Col> */}
                {
                  !isEcity &&
                  <Col xs={2}>
                    <label className='col-xs-6 text-nowrap'><Translate value="00_dashsign_30_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                    <Col xs={7}>
                      <Field name='amount00_30' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount00_30)}` || 0} />
                    </Col>
                  </Col>
                }
                {
                  isEcity &&
                  <div>
                    <Col xs={2}>
                      <label className='col-xs-6 text-nowrap'><Translate value="00_dashsign_07_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={7}>
                        <Field name='amount00_07' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount00_07)}` || 0} />
                      </Col>
                    </Col>
                    <Col xs={2}>
                      <label className='col-xs-6 text-nowrap'><Translate value="08_dashsign_30_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                      <Col xs={7}>
                        <Field name='amount08_30' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount08_30)}` || 0} />
                      </Col>
                    </Col>
                  </div>
                }
                  <Col xs={ 2 }>
                    <label className='col-xs-6 text-nowrap'><Translate value="31_dashsign_60_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                    <Col xs={ 7 }>
                      <Field name='amount31_60' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount31_60)}` || 0}/>
                    </Col>
                  </Col>
                  <Col xs={ 2 }>
                    <label className='col-xs-6 text-nowrap'><Translate value="61_dashsign_90_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                    <Col xs={ 7 }>
                      <Field name='amount61_90' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount61_90)}` || 0}/>
                    </Col>
                  </Col>
                  <Col xs={ 2 }>
                    <label className='col-xs-6 text-nowrap'><Translate value="91_plussign_days" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                    <Col xs={ 7 }>
                      <Field name='amount_91' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.amount_91)}` || 0}/>
                    </Col>
                  </Col>
                  <Col xs={ 2 }>
                    <label className='col-xs-6 text-nowrap'><Translate value="grand_total" /><span className="dollar-sign"> $$</span>:&nbsp;</label>
                    <Col xs={ 7 }>
                      <Field name='grand_amount' component={DisabledInputField} placeholder={`${numberWithCommas(this.state.grand_amount)}` || 0}/>
                    </Col>
                  </Col>
                </Panel>
              </Col>
            </Row>
          </Col>
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML: Purchase Order List
      //---------------
    )
  }
}


export default CustomerStatementMain;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/customerStatementMain.jsx